import { apiSlice } from "./api.slice";
import { FileSystemSvms, FileSystemVolumes, RegisteredFileSystem } from "./api.types";

export interface RegisterdFileSystemsParams {
    accountId: string,
    workspaceId: string
}

interface FileSystemsParams {
    accountId: string,
    credentialsId: string,
    region: string,
    fsId: string,
    nextToken?: string
}

const BASE_URL = import.meta.env.VITE_API_BLUEXP_BASE_URL;
const isDemo = import.meta.env.VITE_SIMULATE_API === "true";

const groupApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRegisterdFileSystems: builder.query<RegisteredFileSystem, RegisterdFileSystemsParams>({
            query: ({ accountId, workspaceId }) => {
                return {
                    url: `${BASE_URL}/accounts/${accountId}/fsx/v2/bluexp/file-systems`,
                    params: { workspaceId },
                    headers: {
                        'x-simulator': isDemo ? 'true' : 'false'
                    }
                }
            },
            providesTags: [{ type: 'registeredFileSystems' }]
        }),
        getFileSystems: builder.query<RegisteredFileSystem, FileSystemsParams>({
            query: ({ accountId, credentialsId, region, fsId }) => {
                return {
                    url: `${BASE_URL}/accounts/${accountId}/fsx/v2/credentials/${credentialsId}/regions/${region}/file-systems/${fsId}`,
                    headers: {
                        'x-simulator': isDemo ? 'true' : 'false'
                    }
                }
            },
            providesTags: [{ type: 'fileSystems' }]
        }),
        getVolumes: builder.query<FileSystemVolumes, FileSystemsParams>({
            query: ({ accountId, credentialsId, region, fsId, nextToken }) => {
                return {
                    url: `${BASE_URL}/accounts/${accountId}/fsx/v2/credentials/${credentialsId}/regions/${region}/file-systems/${fsId}/volumes`,
                    params: { nextToken },
                    headers: {
                        'x-simulator': isDemo ? 'true' : 'false'
                    }
                }
            },
            providesTags: [{ type: 'volumes' }]
        }),
        getSvms: builder.query<FileSystemSvms, FileSystemsParams>({
            query: ({ accountId, credentialsId, region, fsId, nextToken }) => {
                return {
                    url: `${BASE_URL}/accounts/${accountId}/fsx/v2/credentials/${credentialsId}/regions/${region}/file-systems/${fsId}/svms`,
                    params: { nextToken },
                    headers: {
                        'x-simulator': isDemo ? 'true' : 'false'
                    }
                }
            },
            providesTags: [{ type: 'svms' }]
        })
    })
});

export const {
    useGetRegisterdFileSystemsQuery,
    useLazyGetRegisterdFileSystemsQuery,
    useLazyGetFileSystemsQuery,
    useGetVolumesQuery,
    useGetSvmsQuery
} = groupApiSlice;